/**
 * Format an on-chain integer token amount without converting it to a JS
 * number. Keeping the value as bigint avoids precision loss and prevents the
 * browser from switching small balances to scientific notation.
 */
export function formatTokenAmount(raw: string, decimals: number): string {
  if (!Number.isInteger(decimals) || decimals < 0) return raw;

  try {
    const value = BigInt(raw);
    const negative = value < 0n;
    const absolute = negative ? -value : value;
    const digits = absolute.toString().padStart(decimals + 1, "0");
    const integerPart =
      decimals === 0 ? digits : digits.slice(0, Math.max(1, digits.length - decimals));
    const fractionalPart =
      decimals === 0 ? "" : digits.slice(-decimals).replace(/0+$/, "");
    const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return `${negative ? "-" : ""}${groupedInteger}${
      fractionalPart.length > 0 ? `.${fractionalPart}` : ""
    }`;
  } catch {
    return raw;
  }
}
